import { AppMultiSelect, AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../helpers/Translator';
import useIsMounted from '../../hooks/useIsMounted';

export default function EvidenceTypeSelect(props) {
  const {
    value,
    onHandleChange,
    className = 'mb-2',
    isMulti = true,
    hasSearchBox = false,
    hasSelectOptions = false,
    isClearable = false,
  } = props;
  const isMounted = useIsMounted();

  return (
    <AppMultiSelect
      options={[
        { value: 1, label: 'Visual' },
        { value: 2, label: 'Documental' },
        { value: 3, label: 'Otros' },
      ]}
      title={ReactDOMServer.renderToString(
        <Translator file="module-legalCompliance" name="types-evidence" />
      )}
      placeholder={ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="select-one-more-types-evidence"
        />
      )}
      value={value}
      onChange={(opt) => onHandleChange(opt)}
      isMulti={isMulti}
      icon={<AppRemixIcon icon="drag-move-2" filled />}
      isClearable={isClearable}
    />
  );
}
